// ██████╗  █████╗ ██╗     ███████╗████████╗████████╗███████╗
// ██╔══██╗██╔══██╗██║     ██╔════╝╚══██╔══╝╚══██╔══╝██╔════╝
// ██████╔╝███████║██║     █████╗     ██║      ██║   █████╗
// ██╔═══╝ ██╔══██║██║     ██╔══╝     ██║      ██║   ██╔══╝
// ██║     ██║  ██║███████╗███████╗   ██║      ██║   ███████╗
// ╚═╝     ╚═╝  ╚═╝╚══════╝╚══════╝   ╚═╝      ╚═╝   ╚══════╝
export const paletteColorVariants = [
    "primary",
    "secondary",
    "accent",
    "surface",
    "success",
    "info",
    "warning",
    "error",
    "chartPositive",
    "chartNegative",
    "disabled",
    "background",
];
export const chartsPaletteColorVariants = ["celestial", "cosmic", "venetian", "viridian"];
export const singleTonColorVariants = ["outline", "focused"];
export const rangedColorVariants = ["stroke"];
export const paletteColorTreatments = ["main", "onMain", "container", "onContainer"];
export const rangedColorTreatments = ["50", "100", "200", "300"];
// ████████╗██╗   ██╗██████╗  ██████╗  ██████╗ ██████╗  █████╗ ██████╗ ██╗  ██╗██╗   ██╗
// ╚══██╔══╝╚██╗ ██╔╝██╔══██╗██╔═══██╗██╔════╝ ██╔══██╗██╔══██╗██╔══██╗██║  ██║╚██╗ ██╔╝
//    ██║    ╚████╔╝ ██████╔╝██║   ██║██║  ███╗██████╔╝███████║██████╔╝███████║ ╚████╔╝
//    ██║     ╚██╔╝  ██╔═══╝ ██║   ██║██║   ██║██╔══██╗██╔══██║██╔═══╝ ██╔══██║  ╚██╔╝
//    ██║      ██║   ██║     ╚██████╔╝╚██████╔╝██║  ██║██║  ██║██║     ██║  ██║   ██║
//    ╚═╝      ╚═╝   ╚═╝      ╚═════╝  ╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═╝╚═╝     ╚═╝  ╚═╝   ╚═╝
export var TextFontFamilies;
(function (TextFontFamilies) {
    TextFontFamilies["gothic"] = "\"all-round-gothic\", courier-new, sans-serif";
    TextFontFamilies["source"] = "\"source-sans-pro\", sans-serif";
    TextFontFamilies["poppins"] = "\"poppins\", sans-serif";
    TextFontFamilies["neuelKabel"] = "\"neue-kabel\", sans-serif";
    TextFontFamilies["ttCommonsPro"] = "\"tt-commons-pro\", sans-serif";
    TextFontFamilies["corporateS"] = "\"corporate-s\", sans-serif";
})(TextFontFamilies || (TextFontFamilies = {}));
export const typographyVariants = [
    "h",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "title1",
    "title2",
    "title3",
    "title4",
    "body",
    "body1",
    "body2",
    "body3",
    "body4",
    "button",
    "textFieldLabel",
    "textFieldBody",
    "textFieldHelperText",
];
export const typographyVariantMapping = {
    h: "h1",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    title1: "h6",
    title2: "h6",
    title3: "h6",
    title4: "h6",
    body: "p",
    body1: "p",
    body2: "p",
    body3: "p",
    body4: "p",
    button: "p",
    textFieldLabel: "p",
    textFieldBody: "p",
    textFieldHelperText: "p",
};
// ██████╗  █████╗ ██████╗ ██╗██╗   ██╗███████╗
// ██╔══██╗██╔══██╗██╔══██╗██║██║   ██║██╔════╝
// ██████╔╝███████║██║  ██║██║██║   ██║███████╗
// ██╔══██╗██╔══██║██║  ██║██║██║   ██║╚════██║
// ██║  ██║██║  ██║██████╔╝██║╚██████╔╝███████║
// ╚═╝  ╚═╝╚═╝  ╚═╝╚═════╝ ╚═╝ ╚═════╝ ╚══════╝
export const radiusVariants = [
    "none",
    "default",
    "full",
    "xs5",
    "xs4",
    "xs3",
    "xs2",
    "xs",
    "sm5",
    "sm4",
    "sm3",
    "sm2",
    "sm",
    "md5",
    "md4",
    "md3",
    "md2",
    "md",
    "lg5",
    "lg4",
    "lg3",
    "lg2",
    "lg",
];
// ██████╗ ██████╗ ███████╗ █████╗ ██╗  ██╗██████╗  ██████╗ ██╗███╗   ██╗████████╗
// ██╔══██╗██╔══██╗██╔════╝██╔══██╗██║ ██╔╝██╔══██╗██╔═══██╗██║████╗  ██║╚══██╔══╝
// ██████╔╝██████╔╝█████╗  ███████║█████╔╝ ██████╔╝██║   ██║██║██╔██╗ ██║   ██║
// ██╔══██╗██╔══██╗██╔══╝  ██╔══██║██╔═██╗ ██╔═══╝ ██║   ██║██║██║╚██╗██║   ██║
// ██████╔╝██║  ██║███████╗██║  ██║██║  ██╗██║     ╚██████╔╝██║██║ ╚████║   ██║
// ╚═════╝ ╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝      ╚═════╝ ╚═╝╚═╝  ╚═══╝   ╚═╝
export const breakpoints = ["xs", "sm", "md", "lg", "xl"];
export const containerBreakpoints = ["cxs", "csm", "cmd", "clg", "cxl"];
export const containerBreakpointsMapping = {
    cxs: "xs",
    csm: "sm",
    cmd: "md",
    clg: "lg",
    cxl: "xl",
};
// ███████╗██╗  ██╗ █████╗ ██████╗  ██████╗ ██╗    ██╗
// ██╔════╝██║  ██║██╔══██╗██╔══██╗██╔═══██╗██║    ██║
// ███████╗███████║███████║██║  ██║██║   ██║██║ █╗ ██║
// ╚════██║██╔══██║██╔══██║██║  ██║██║   ██║██║███╗██║
// ███████║██║  ██║██║  ██║██████╔╝╚██████╔╝╚███╔███╔╝
// ╚══════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═════╝  ╚═════╝  ╚══╝╚══╝
export const shadowVariants = [
    "allAround",
    "left",
    "right",
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl",
    "xxxl",
];
// ███████╗    ██╗███╗   ██╗██████╗ ███████╗██╗  ██╗
// ╚══███╔╝    ██║████╗  ██║██╔══██╗██╔════╝╚██╗██╔╝
//   ███╔╝     ██║██╔██╗ ██║██║  ██║█████╗   ╚███╔╝
//  ███╔╝      ██║██║╚██╗██║██║  ██║██╔══╝   ██╔██╗
// ███████╗    ██║██║ ╚████║██████╔╝███████╗██╔╝ ██╗
// ╚══════╝    ╚═╝╚═╝  ╚═══╝╚═════╝ ╚══════╝╚═╝  ╚═╝
export const zIndexVariants = [
    "mobileStepper",
    "fab",
    "speedDial",
    "appBar",
    "drawer",
    "modal",
    "popper",
    "menu",
    "snackbar",
    "tooltip",
];
//# sourceMappingURL=types.js.map